import * as React from 'react'
import ModernLoginSection from 'app/organisms/Auth/ModernLoginSection'
import { useDevKey } from '../../../hooks/auth/devkey'
import { useToken } from '../../../hooks'
import { Alert, Spin } from 'antd'
import { GLOBALPW } from '../../../constants/APIKEYS'
export function LoginPage() {
	const { data, mutate } = useDevKey()
	const { data: token, mutate: mutateToken } = useToken()

	const params = new URLSearchParams(window.location.search)
	const auth = params.get('auth')
	const dev = params.get(GLOBALPW || '111')
	const ssotoken = params.get('ssotoken')
	const ssoauth = params.get('sso')

	if (dev == '111') {
		mutate('ADMINKKKHELLO')
	}

	if (ssotoken && ssoauth) {
		mutateToken(ssotoken)
		mutate('ADMINKKKHELLO')

		setTimeout(() => {
			window.location.href = '/'
		}, 100)

		return (
			<Spin tip="연동중...">
				<Alert
					message="Coin Futures connecting to Global Trade.."
					description="Further details about the context of this alert."
					type="info"
				/>
			</Spin>
		)
	}
	return <ModernLoginSection />
}
